export default {"src":"/_next/static/media/call-icon.8a573653.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};